import React, { useEffect, useState } from 'react';
import axios from "../axios";
import { Link, useNavigate } from "react-router-dom";
import {
    Container,
    CreateBtn,
    DetailsBtns,
    DetailsHeading, Flex,
    H1,
    ListHeading, SmallSpacing,
    Table,
    Td,
    Th,
    Tr
} from "../../styles";
import useAdminStatus from "../hooks/useAdminStatus";

const Lecturers = () => {
    const [lecturers, setLecturers] = useState([]);
    const navigate = useNavigate();
    const { isAdmin } = useAdminStatus();

    useEffect(() => {
        axios.get('/lecturers/')
            .then(response => {
                setLecturers(response.data);
            })
            .catch(error => {
                console.error(error);
            });
    }, []);

    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete this lecturer?")) {
            axios.delete(`/lecturer/delete/${id}/`)
                .then(() => {
                    setLecturers(lecturers.filter(lecturer => lecturer.lecturer_id !== id));
                })
                .catch(error => {
                    console.error("There was an error deleting the lecturer!", error);
                });
        }
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}${month}${day}`;
    };

    return (
        <Container>
            <ListHeading>
                <H1>Lecturer List</H1>
                 {isAdmin && (
                <Link to="/lecturer/create">
                    <CreateBtn>
                        Add Lecturer
                    </CreateBtn>
                </Link>)}
            </ListHeading>
            <Table>
                <Tr>
                    <Th>ID</Th>
                    <Th>Username</Th>
                    <Th>Lecturer Name</Th>
                    <Th>Email</Th>
                    <DetailsHeading>Details</DetailsHeading>
                </Tr>
                {lecturers.map((lecturer) => (
                    <Tr key={lecturer.lecturer_id}>
                        <Td>{lecturer.lecturer_id}</Td>
                        <Td>{lecturer.first_name.toLowerCase()}-{formatDate(lecturer.dob)}</Td>
                        <Td>{lecturer.first_name} {lecturer.last_name}</Td>
                        <Td>{lecturer.email}</Td>
                        <DetailsBtns>
                            <Flex>
                                <Link to={`/lecturer/${lecturer.lecturer_id}`}>View</Link>
                                 {isAdmin && (<>
                                <SmallSpacing/>
                                <Link to={`/lecturer/update/${lecturer.lecturer_id}`}>Update</Link>
                                <SmallSpacing/>
                                <Link to="#" onClick={() => handleDelete(lecturer.lecturer_id)}>Delete</Link>
                            </>)}
                                 </Flex>
                        </DetailsBtns>
                    </Tr>
                ))}
            </Table>
        </Container>
    );
};

export default Lecturers;
